import React from "react";

import OrderItem from "components/OrderItem";
import CustomFormatNumber from "components/CustomFormatNumber";
import TwoCellRow from "components/TwoCellRow";
import NextButton from "components/NextButton";
import successIcon from "assets/images/success-icon.json";
import LottiePlayer from "components/LottiePlayer";

import { useSideModalScrollToTop } from "hooks";

const OrderSuccess = ({
    className = "",
    onBackToProperty,
    subHeading,
    buttonText,
    lineBelowImage,
    orderItemData,
    rowData = null,
    buttonClass = "",
    content,
    backSlideEffect = "",
}) => {
    useSideModalScrollToTop();

    return (
        <>
            <div className={`order-success ${className} ${backSlideEffect}`}>
                <h3 className="text-center">{subHeading}</h3>
                <LottiePlayer
                    autoplay
                    loop={false}
                    keepLastFrame
                    speed={1}
                    src={successIcon}
                    style={{ width: 94, marginTop: 40, marginBottom: 40 }}
                />
                <p className="text-center mb-10">{lineBelowImage}</p>
                <OrderItem
                    equalTitle={false}
                    orderFlag={orderItemData.flag}
                    tag={orderItemData.tag}
                    className={`mb-10 ${orderItemData.className}`}
                    image={orderItemData.image}
                    title={orderItemData.title}
                    // city={orderItemData.city}
                    shares={orderItemData.shares}
                    price={orderItemData.price}
                    date={orderItemData.date}
                    perSharePrice={orderItemData.pricePerShare}
                />

                {rowData
                    ? rowData.map((row, index) => {
                          return (
                              <TwoCellRow
                                  key={index}
                                  removeLClass
                                  removeRClass
                                  lClassname="light-grey-color mb-5"
                                  rClassname="light-grey-color text-14 fw-600 mb-5"
                                  left={row.left}
                                  right={<CustomFormatNumber value={row.right} />}
                              />
                          );
                      })
                    : null}

                <div className="border-x" />

                {content ? <div>{content}</div> : null}
            </div>
            <div className="bottom-bar-container single-button">
                <NextButton className={`mw-100 mr-1 ${buttonClass}`} title={buttonText} onClick={onBackToProperty} />
            </div>
        </>
    );
};

export default OrderSuccess;
